// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/forms/Blocks/ContactUs.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/forms/Blocks/ContactUs.tsx");
  import.meta.hot.lastModified = "1740183864613.5093";
}
// REMIX HMR END

import { Fragment } from "react";
import Form from "../Form";
import { schema } from "~/routes/resources.request";
import { HoneypotInputs } from "remix-utils/honeypot/react";
const Errors = {
  EMAIL_REGISTERED: <Fragment>
      <p className="font-bold">We’ve already received your request.</p>
      <p>We’ll contact you as soon as possible.</p>
    </Fragment>,
  UNEXPECTED_ERROR: <Fragment>
      <p className="font-bold">Sorry, we couldn't send your request.</p>
      <p>Please try again or contact hq@octahedroid.com</p>
    </Fragment>
};
export default function ContactUs({
  fetcher,
  preSelectedValue
}) {
  return <Form id="requestDemoForm" action="/resources/request" buttonLabel="Submit" fetcher={fetcher} mode="onBlur" className="space-y-4 w-full flex flex-col items-center children:w-full" schema={schema} options={{
    interestedIn: [{
      name: "I’m interested in",
      value: "I’m interested in"
    }, {
      name: "Decoupled Architectures",
      value: "Decoupled Architectures"
    }, {
      name: "Custom Web App Development",
      value: "Custom Web App Development"
    }, {
      name: "Drupal Digital Experiences",
      value: "Drupal Digital Experiences"
    }, {
      name: "Quality Assurance (QA)",
      value: "Quality Assurance (QA)"
    }, {
      name: "Web Accessibility",
      value: "Web Accessibility"
    }, {
      name: "Audit SEO & Performance",
      value: "Audit SEO & Performance"
    }, {
      name: "DevOps",
      value: "DevOps"
    }, {
      name: "E-commerce",
      value: "E-commerce"
    }, {
      name: "Other",
      value: "Other"
    }]
  }} values={{
    interestedIn: preSelectedValue
  }} multiline={["comments"]}>
      {({
      Field,
      Button
    }) => <Fragment>
          <HoneypotInputs label="Please leave this field blank" />
          <Field name="name" label="Name" />
          <Field name="email" label="Email" />
          <Field name="companyName" label="Company" />
          <Field name="interestedIn" />
          <Field name="comments" label="Message" />
          {fetcher.data?.errors?._global && <div className="mt-4 text-center bg-error-600 p-4 text-white">
              {Errors[fetcher.data?.errors?._global]}
            </div>}
          <Button className="!w-fit justify-self-end ml-auto">Submit</Button>
        </Fragment>}
    </Form>;
}
_c = ContactUs;
var _c;
$RefreshReg$(_c, "ContactUs");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;